'use client';

import cx from 'classix';
import {
  format,
  isEqual,
  isPast,
} from 'date-fns';
import {
  useLocale,
  useTranslations,
} from 'next-intl';
import { type DateTimeFormatOptions } from 'use-intl';

import { type ListingDataView } from '@/features/listing/types/listing-types';

import styles from './listing-move-in-date.module.scss';

interface ListingMoveInDateProps {
  moveInDate: Date;
  isListingPerson: boolean;
  view?: ListingDataView;
}

export default function ListingMoveInDate(props: ListingMoveInDateProps) {
  const {
    isListingPerson,
    moveInDate,
    view = 'isCard',
  } = props;

  const translationsCard = useTranslations('listing.card');

  const availableDate = new Date(moveInDate);
  const currentDate = new Date();
  const isToday = isEqual(format(availableDate, 'MM/dd/yyyy'), format(currentDate, 'MM/dd/yyyy'));
  const isImmediately = isPast(format(availableDate, 'MM/dd/yyyy')) && !isToday;
  const locale = useLocale();

  const options: DateTimeFormatOptions = {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  };
  const formattedDate = new Intl.DateTimeFormat(locale, options).format(availableDate);

  return (
    <p
      className={cx(
        styles.listingMoveInDate,
        styles[`listingMoveInDate__${view}`],
      )}
    >
      <span className={styles.listingMoveInDate_move}>
        {`${translationsCard(isListingPerson ? 'move-in-date' : 'available-date')}${view === 'isCard' ? ':' : ''}`}
      </span>
      {view === 'isCard' && ' '}
      <span className={styles.listingMoveInDate_date}>
        {isImmediately ? translationsCard('immediately') : formattedDate}
      </span>
    </p>
  );
}
